import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>© {new Date().getFullYear()} Mi Blog de Tecnología. Todos los derechos reservados.</p>
    </footer>
  );
}

export default Footer;
